import BaseModelInstance from './base.model'
import { UserEopolicy as ModelDefinition } from './model-definitions'

class UserEopolicy extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserEopolicy
